'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var transition = _interopDefault(require('styled-transition-group'));
var Dismiss = require('./components/Dismiss.js');

var _templateObject;
var error = function error() {
  return {
    borderColor: '#f00',
    backgroundColor: '#f00',
    color: '#fff'
  };
};
var Container = styled.div.withConfig({
  componentId: "sc-1yoyqmn-0"
})(["cursor:", ";border-style:", ";border-color:", ";border-width:", ";border-radius:", ";color:", ";background-color:", ";padding:", ";"], function (props) {
  return props.onClick ? 'pointer' : '';
}, function (props) {
  return props.s.borderStyle || 'solid';
}, function (props) {
  return props.s.borderColor || '#000';
}, function (props) {
  return props.s.borderWidth || '1px';
}, function (props) {
  return props.s.borderRadius || '0.125rem';
}, function (props) {
  return props.s.color || '#000';
}, function (props) {
  return props.s.backgroundColor || '#fff';
}, function (props) {
  return props.s.padding || '1.25rem';
});
var ScaleInOut = transition.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:enter {\n    opacity: 0;\n    transform: scale(0);\n  }\n  &:enter-active {\n    opacity: 1;\n    transform: scale(1);\n    transition-property: opacity, transform;\n    transition-duration: ", "ms;\n    transition-timing-function: ease-in;\n  }\n  &:exit {\n    opacity: 1;\n    transform: scale(1);\n  }\n  &:exit-active {\n    opacity: 0;\n    transform: scale(0);\n    transition-property: opacity, transform;\n    transition-duration: ", "ms;\n    transition-timing-function: ease-in;\n  }\n"])), function (props) {
  return props.timeout;
}, function (props) {
  return props.timeout;
});
var Cell = styled.td.withConfig({
  componentId: "sc-1yoyqmn-1"
})(["svg{display:block;}vertical-align:top;width:", ";padding-right:", ";"], function (props) {
  return props.fullwidth ? '100%' : 'auto';
}, function (props) {
  if (!props.fullwidth) return '';
  if (props.s.padding) {
    var values = props.s.padding.trim().replace(/\s{2,}/g, ' ').split(' ');
    if (values.length > 1) return values[1];
    return props.s.padding;
  }
  return '1.25rem';
});
var Alert = function Alert(_ref) {
  var children = _ref.children,
    show = _ref.show,
    onClick = _ref.onClick,
    dismissible = _ref.dismissible,
    dismiss = _ref.dismiss,
    dismissOnClick = _ref.dismissOnClick,
    s = _ref.s,
    timeout = _ref.timeout;
  return /*#__PURE__*/React.createElement(ScaleInOut, {
    unmountOnExit: true,
    in: show,
    timeout: timeout
  }, /*#__PURE__*/React.createElement(Container, {
    s: s,
    onClick: onClick,
    tabIndex: onClick ? 0 : -1
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(Cell, {
    s: s,
    fullwidth: dismissible,
    tabIndex: "0"
  }, children), dismissible && /*#__PURE__*/React.createElement(Cell, {
    s: s
  }, dismiss || /*#__PURE__*/React.createElement(Dismiss.default, {
    s: s,
    onClick: dismissOnClick,
    tabIndex: dismissOnClick ? 0 : -1
  })))))));
};
Alert.defaultProps = {
  show: false,
  s: {},
  dismissible: false,
  dismiss: null,
  onClick: null,
  dismissOnClick: null,
  timeout: 200
};
Alert.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool,
  onClick: PropTypes.func,
  dismissible: PropTypes.bool,
  dismiss: PropTypes.node,
  dismissOnClick: PropTypes.func,
  s: PropTypes.shape({
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.string,
    borderRadius: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string
  }),
  timeout: PropTypes.number
};

exports.Dismiss = Dismiss.default;
exports.default = Alert;
exports.error = error;
